<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-10'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메인화면 관리 - 팝업 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminPopupManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" @click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" @click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 리스트 정렬은 ID와 무관하며, 상단이 우선입니다.</p>
            <p>2. 왼쪽 핸들을 드래그하여 순서를 변경할 수 있습니다.</p>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import {
  get_popup_list,
  update_popup_order,
  delete_popup
} from '../../ETC/Axios.vue'
import { fmtDate } from '../../ETC/Validation.vue'

export default {
  name: 'AdminPopupManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        const id = this.tabulator.getSelectedData()[0].popup_id
        window.location.href = `/AdminPopupManagementAdd?popup_id=${id}`
      }
    },
    delete_row () {
      const ids = this.tabulator.getSelectedData().map(x => x.popup_id)
      if (ids.length === 0) {
        alert('삭제할 데이터를 선택해주세요.')
        return
      }

      delete_popup(ids).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자에게 확인해주세요.')
        } else {
          alert('삭제가 완료되었습니다.')
          window.location.reload()
        }
      })
    }
  },
  mounted () {
    get_popup_list().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          { rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30 },
          {
            formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) { cell.getRow().toggleSelect() }
          },
          { title: 'ID', field: 'popup_id', headerSort: false },
          { title: '타이틀', field: 'title', headerSort: false },
          {
            title: '사용 여부',
            field: 'is_use',
            headerSort: false,
            formatter: (cell) => {
              const v = Number(cell.getValue())
              return v === 1 ? '사용' : '미사용'
            }
          },
          { title: '디바이스', field: 'device_type', headerSort: false },
          { title: '노출 시작', field: 'start_at', headerSort: false, formatter: (cell) => fmtDate(cell.getValue()) },
          { title: '노출 종료', field: 'end_at', headerSort: false, formatter: (cell) => fmtDate(cell.getValue()) },
          { title: '등록 일자', field: 'created_at', headerSort: false, formatter: (cell) => fmtDate(cell.getValue()) },
          { title: '수정 일자', field: 'updated_at', headerSort: false, formatter: (cell) => fmtDate(cell.getValue()) }
        ]
      })

      this.tabulator.on('rowMoved', function (row) {
        const table = row.getTable()
        const payload = []
        let order = 1
        table.getRows().forEach(r => {
          payload.push({
            popup_id: r.getData().popup_id,
            sort_order: order
          })
          order++
        })

        update_popup_order(payload).then(result => {
          if (result === undefined) {
            alert('순서가 변경되지 않았습니다. 관리자에게 확인해주세요.')
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminPopupManagement.vue